import { AnbieterAggregation } from './anbieter-aggregation';
import { BeginntermineAggregation } from './beginntermine-aggregation';
import { FoerderartAggregation } from './foerderart-aggregation';
import { Kosten } from './kosten';
import { RegionKurzKursnet } from './regionenliste';

export enum AggregationKey {
  Dauer = 'DAUER',
  Regionen = 'REGIONEN',
  Lernformen = 'LERNFORMEN',
  AnzahlAusgefiltert = 'ANZAHL_AUSGEFILTERT',
  AnzahlGesamt = 'ANZAHL_ANGEBOTE_GESAMT',
  Beginntermin = 'BEGINNTERMIN',
  Unterrichtszeit = 'UNTERRICHTSZEIT',
  Weiterbildungsart = 'WEITERBILDUNGSART',
  Kosten = 'KOSTEN',
  Anbieter = 'ANBIETER',
  Barrierefreiheit = 'BARRIEREFREIHEIT',
  Foerderart = 'FOERDERART'
}

export enum LernformKey {
  Vorort = 'VORORT',
  Fern = 'FERN',
  Kombi = 'KOMBI',
  Digital = 'DIGITAL'
}

export interface LERNFORMEN {
  [LernformKey.Vorort]?: {
    [n in number]?: number;
  };
  [LernformKey.Fern]?: {
    [n in number]?: number;
  };
  [LernformKey.Kombi]?: {
    [n in number]?: number;
  };
  [LernformKey.Digital]?: {
    [n in number]?: number;
  };
}

// Interface für Filter-Aggregationen aus dem Backend
// Zugriff auf die Felder oft über JS-Syntax durch implizite Namens-Nennung,
// wie z.B. Object.values(FOERDERART)
export interface DefaultAggregations {
  [AggregationKey.Dauer]: {
    [key: string]: number;
  };
  [AggregationKey.Regionen]: {
    [region in RegionKurzKursnet]?: number;
  };
  [AggregationKey.Lernformen]: LERNFORMEN;
  [AggregationKey.AnzahlAusgefiltert]: {
    COUNT: number;
  };
  [AggregationKey.AnzahlGesamt]: {
    COUNT: number;
  };
  [AggregationKey.Beginntermin]: {
    [key: number]: BeginntermineAggregation;
  };
  [AggregationKey.Unterrichtszeit]: {
    [key: number]: number;
  };
  [AggregationKey.Weiterbildungsart]: {
    [key: string]: number;
  };
  [AggregationKey.Kosten]: {
    [key in Kosten]?: number;
  };
  [AggregationKey.Barrierefreiheit]: {
    [key: string]: number;
  };
  [AggregationKey.Foerderart]: {
    [key: string]: FoerderartAggregation;
  };
}

export interface AnbieterAggregations {
  [AggregationKey.Anbieter]: {
    [key: number]: AnbieterAggregation;
  };
}

export interface Aggregations extends AnbieterAggregations, DefaultAggregations {}

export const EMPTY: () => Aggregations = (): Aggregations => ({
  ANBIETER: {},
  ANZAHL_AUSGEFILTERT: {
    COUNT: 0
  },
  ANZAHL_ANGEBOTE_GESAMT: {
    COUNT: 0
  },
  UNTERRICHTSZEIT: {},
  WEITERBILDUNGSART: {},
  KOSTEN: {},
  BARRIEREFREIHEIT: {
    RAEUMLICHE_UND_DIGITALE_BARRIEREFREIHEIT: 0,
    DIGITALE_BARRIEREFREIHEIT: 0,
    RAEUMLICHE_BARRIEREFREIHEIT: 0
  },
  BEGINNTERMIN: {},
  DAUER: {},
  FOERDERART: {},
  LERNFORMEN: {},
  REGIONEN: {}
});
